import React, { useState } from "react";
import storageManager from "../Utility/StorageManager";

export const LoginContext = React.createContext();

const LoginContextProvider = ({ children }) => {
  const [loginToken, setLoginToken] = useState(storageManager.getItem("tokens"));

  const setTokens = (data) => {
    storageManager.setItem("tokens", data);
    setLoginToken(storageManager.getItem("tokens"));
  };

  const [passwordIsReset, setPasswordIsReset] = useState(false);

  return (
    <LoginContext.Provider
      value={{
        loginToken,
        setLoginToken: setTokens,
        passwordIsReset,
        setPasswordIsReset,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export default LoginContextProvider;
